module.exports = __webpack_public_path__ + "img/flower_leaf_29.85257567.png";